import { render, staticRenderFns } from "./EhrNavList.vue?vue&type=template&id=0d76d8c6&scoped=true&lang=pug"
import script from "./EhrNavList.vue?vue&type=script&lang=js"
export * from "./EhrNavList.vue?vue&type=script&lang=js"
import style0 from "./EhrNavList.vue?vue&type=style&index=0&id=0d76d8c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d76d8c6",
  null
  
)

export default component.exports